var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispatchIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 12.4167C7.81956 12.4167 8.28588 12.2235 8.6297 11.8797C8.97351 11.5359 9.16667 11.0696 9.16667 10.5833C9.16667 10.0971 8.97351 9.63079 8.6297 9.28697C8.28588 8.94315 7.81956 8.75 7.33333 8.75C6.8471 8.75 6.38079 8.94315 6.03697 9.28697C5.69315 9.63079 5.5 10.0971 5.5 10.5833C5.5 11.0696 5.69315 11.5359 6.03697 11.8797C6.38079 12.2235 6.8471 12.4167 7.33333 12.4167ZM16.5 12.4167C16.9862 12.4167 17.4525 12.2235 17.7964 11.8797C18.1402 11.5359 18.3333 11.0696 18.3333 10.5833C18.3333 10.0971 18.1402 9.63079 17.7964 9.28697C17.4525 8.94315 16.9862 8.75 16.5 8.75C16.0138 8.75 15.5475 8.94315 15.2036 9.28697C14.8598 9.63079 14.6667 10.0971 14.6667 10.5833C14.6667 11.0696 14.8598 11.5359 15.2036 11.8797C15.5475 12.2235 16.0138 12.4167 16.5 12.4167Z",
    stroke: "white",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21258 10.5833H13.7501V1.05C13.7501 0.904131 13.6921 0.764236 13.589 0.661091C13.4858 0.557946 13.3459 0.5 13.2001 0.5H0.916748M5.17925 10.5833H3.30008C3.22785 10.5833 3.15633 10.5691 3.08961 10.5415C3.02288 10.5138 2.96224 10.4733 2.91117 10.4222C2.8601 10.3712 2.81959 10.3105 2.79195 10.2438C2.76431 10.1771 2.75008 10.1056 2.75008 10.0333V5.54167",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 3.25H5.50016",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.25H18.8925C18.9988 3.25003 19.1028 3.28086 19.192 3.33878C19.2811 3.3967 19.3516 3.47921 19.3948 3.57633L21.0357 7.26867C21.0669 7.33878 21.0832 7.41465 21.0833 7.49142V10.0333C21.0833 10.1056 21.0691 10.1771 21.0415 10.2438C21.0138 10.3105 20.9733 10.3712 20.9222 10.4222C20.8712 10.4733 20.8105 10.5138 20.7438 10.5415C20.6771 10.5691 20.6056 10.5833 20.5333 10.5833H18.7917M13.75 10.5833H14.6667",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchIconW);
export default __webpack_public_path__ + "static/media/dispatchIconW.0b2c16b52eb0d975adde0a86344a3617.svg";
export { ForwardRef as ReactComponent };